/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

type CheckoutErrorData = { error?: string; formError?: string; step?: string } | null | undefined;

export function getCheckoutDisplayError(data: CheckoutErrorData, step?: string): string | undefined {
    if (!data) return undefined;
    if (step !== undefined && data.step !== step) return undefined;
    const msg = data.error ?? data.formError;
    return typeof msg === 'string' && msg.length > 0 ? msg : undefined;
}
